module.exports = __webpack_public_path__ + "img/588x310-03.42e39e16.png";